module.exports = __webpack_public_path__ + "static/img/bofangluxiang.4e2a341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/bofangluxiang.png
// module id = WPT+
// module chunks = 24